<template>
    <va-create-layout>
        <RetrochargeEvent-form
            :title="title"
            :item="item"
        ></RetrochargeEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
